'use es6';

import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
const CtaPicker = makeAsyncModal(() => import(
/* webpackChunkName: "cta-picker" */
'cta-picker/components/CTAPickerContainer'));
const EmojiPicker = makeAsyncEmojiPickerContent(() => import(
/* webpackChunkName: "emoji-picker" */
'ui-addon-emoji-picker/picker/EmojiPickerContent'));
const FilePicker = makeAsyncModal(() => import(
/* webpackChunkName: "file-picker" */
'DesignManagerIde/components/shared/FilePicker'));
const PersonalizationBrowser = makeAsyncModal(() => import(
/* webpackChunkName: 'personalization-browser' */
'ui-addon-properties'));
const MediaBridgePicker = makeAsyncModal(() => import(
/* webpackChunkName: "media-bridge-picker" */
'media-bridge-lib/components/media-picker/MediaPicker'));
const HubSpotVideoPicker = makeAsyncModal(() => import(
/* webpackChunkName: "hubspot-video-picker" */
'media-bridge-lib/components/media-picker/HubSpotVideoPicker'));
const PersonalizationUpgradeButton = makeAsyncModal(() => import(
/* webpackChunkName: "personalization-upgrade-button" */
'DesignManagerIde/components/shared/PersonalizationUpgradeButton'));
export default {
  CtaPicker,
  EmojiPicker,
  FilePicker,
  PersonalizationBrowser,
  MediaBridgePicker,
  HubSpotVideoPicker,
  PersonalizationUpgradeButton
};